import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";



export const getApiLogs = createAsyncThunk(
    "apiLogs/getApiLogs",
    async ({ token, offset, limit }, { rejectWithValue }) => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_BASE_URL}/logs`,
                {
                    headers: { Authorization: `Bearer ${token}` },
                    params: { offset: offset, limit: limit }
                }
            );
            if (response.data.status) {

                return { offset, response: response.data.response }
            } else {
                return rejectWithValue("Failed to fetch plans");
            }
        } catch (error) {
            return rejectWithValue(error.response?.data || "Unknown error");
        }
    }
);

const initialState = {
    logsData: [],
    isLoading: false,
    error: null,
};

const apiLogsSlice = createSlice({
    name: "apiLogs",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getApiLogs.fulfilled, (state, action) => {
                if (action.payload.offset === 1) {
                    state.logsData = action.payload.response

                } else {
                    state.logsData = [...state.logsData, ...action.payload.response]

                }
            })
            .addCase(getApiLogs.rejected,(state)=>{
                state.logsData=[]
            })

    },
});

export default apiLogsSlice.reducer;
